module.exports = __webpack_public_path__ + "img/11.5c8f0e1d.svg";